import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faPencilAlt,
  faPlus,
  faTrash
} from '@fortawesome/free-solid-svg-icons';

export enum RevisionTipoEventoEnum {
  ADICAO = 'ADICAO',
  EDICAO = 'EDICAO',
  REMOCAO = 'REMOCAO'
}

export const TipoEventoMap: Record<
  keyof typeof RevisionTipoEventoEnum,
  {
    icon: IconProp;
    color: 'module-color' | 'negative' | 'positive' | 'warning' | 'neutral';
  }
> = {
  ADICAO: { icon: faPlus, color: 'positive' },
  EDICAO: { icon: faPencilAlt, color: 'warning' },
  REMOCAO: { icon: faTrash, color: 'negative' }
};

export const TipoEventoLabels: Record<
  keyof typeof RevisionTipoEventoEnum,
  string
> = {
  ADICAO: 'Adição',
  EDICAO: 'Edição',
  REMOCAO: 'Remoção'
};

export const TipoEventoSelectValues = Object.entries(TipoEventoLabels).map(
  ([value, label]) => ({
    value,
    label
  })
);

export type Revchanges = {
  id: string;
  rev: number;
  usuario: string;
  enderecoIp: string;
  metadata: Record<string, string>;
  data: string;
  tabelaAfetada: string;
  tipoEvento: RevisionTipoEventoEnum;
  telaAcesso: string;
  entity: string;
  aplicacao: string;
  nomeUsuario: string;
  impersonatorId: string;
  impersonatorUsername: string;
  clientId: string;
  clientHost: string;
  clientAddress: string;
  idUsuario: string;
  realmName: string;
  usuarioExterno: boolean;
};

export type RevisionField = {
  [key: string]: {
    valor: unknown;
    tipo: string;
    header: string;
  };
};

export type RevisionDiff = {
  field: string;
  oldValue: string;
  newValue: string;
  tipoEvento: RevisionTipoEventoEnum;
  isDiff: boolean;
  dataType: string;
  metadata: Record<string, string>;
};
